module.exports = "/virtual-football-league/img/amblems/left/logos/REAL MALLORCA.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/REAL MALLORCA.png
// module id = 2116
// module chunks = 4